/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  TicketTemplate,
  TicketTemplatesState,
  TicketTemplatesActionTypes,
  CreateTicketTemplatePayload,
  GetTicketTemplatesPending,
  GetTicketTemplatesSuccess,
  GetTicketTemplatesError,
  CreateTicketTemplatePending,
  CreateTicketTemplateError,
  UpdateTicketTemplatePayload,
  UpdateTicketTemplatePending,
  UpdateTicketTemplateSuccess,
  UpdateTicketTemplateError,
  DeleteTicketTemplatePending,
  DeleteTicketTemplateError
} from './types';

// Actions
export const actions = {
  getTicketTemplates: (): TicketTemplatesActionTypes => ({ type: types.GET_TICKET_TEMPLATES.REQUEST }),
  createTicketTemplate: (payload: CreateTicketTemplatePayload): TicketTemplatesActionTypes => ({
    type: types.CREATE_TICKET_TEMPLATE.REQUEST,
    payload
  }),
  updateTicketTemplate: (payload: UpdateTicketTemplatePayload) => ({
    type: types.UPDATE_TICKET_TEMPLATE.REQUEST,
    payload
  }),
  deleteTicketTemplate: (payload: { id: string }): TicketTemplatesActionTypes => ({
    type: types.DELETE_TICKET_TEMPLATE.REQUEST,
    payload
  }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  resetError: () => ({ type: types.RESET_ERROR })
};

// Initial State
export const initialState: TicketTemplatesState = {
  ticketTemplates: [],
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (
  state: TicketTemplatesState = initialState,
  action: TicketTemplatesActionTypes
): TicketTemplatesState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_TICKET_TEMPLATES.PENDING:
      case types.CREATE_TICKET_TEMPLATE.PENDING:
      case types.UPDATE_TICKET_TEMPLATE.PENDING:
      case types.DELETE_TICKET_TEMPLATE.PENDING:
        draft.action.pending = (
          action as
            | GetTicketTemplatesPending
            | CreateTicketTemplatePending
            | UpdateTicketTemplatePending
            | DeleteTicketTemplatePending
        ).payload;
        break;
      case types.GET_TICKET_TEMPLATES.SUCCESS:
        draft.ticketTemplates = (action as GetTicketTemplatesSuccess).payload;
        break;
      case types.CREATE_TICKET_TEMPLATE.SUCCESS:
      case types.DELETE_TICKET_TEMPLATE.SUCCESS:
        draft.action.success = true;
        break;
      case types.UPDATE_TICKET_TEMPLATE.SUCCESS:
        const payload = (action as UpdateTicketTemplateSuccess).payload;
        if (draft.ticketTemplates.length) {
          const ticketTemplateIndex = draft.ticketTemplates.findIndex((t) => t.id === (payload as TicketTemplate).id);
          if (ticketTemplateIndex > -1) {
            Object.assign(draft.ticketTemplates[ticketTemplateIndex], payload);
          }
        }
        break;
      case types.GET_TICKET_TEMPLATES.ERROR:
      case types.UPDATE_TICKET_TEMPLATE.ERROR:
      case types.CREATE_TICKET_TEMPLATE.ERROR:
      case types.DELETE_TICKET_TEMPLATE.ERROR:
        draft.action.error = (
          action as
            | GetTicketTemplatesError
            | CreateTicketTemplateError
            | UpdateTicketTemplateError
            | DeleteTicketTemplateError
        ).payload;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
